import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const StyledTableContainer = withStyles({
  root: {
    borderRadius: '5px',
  },
})(TableContainer);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: '0.7rem',
    padding: '0.3rem 0.4rem',
  },
  body: {
    fontSize: '0.7rem',
    padding: '0.3rem 0.4rem',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.highlightBlue,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    padding: '1rem 0',
    width: '100%',
    height: '100%',
  },
});


const DataTable = ({headers, rows, formatter}) => {
  const classes = useStyles();
  return (
    <StyledTableContainer>
      <Table className={classes.table}>
        <TableHead>
          <StyledTableRow>
            {headers.map((field, i) => <StyledTableCell key={i}>{field}</StyledTableCell>)}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => <StyledTableRow key={i}>{row.map((td, j) => <StyledTableCell key={j}>{formatter ? formatter(td) : td}</StyledTableCell>)}</StyledTableRow>)}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

DataTable.propTypes = {
  headers: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  formatter: PropTypes.func,
};

export default DataTable;
